export class AppSettings {

  //main end point
  public static API_ENDPOINT = 'http://54.175.54.121:8091';

  //SnotifyService notification and confirm dialog
  public static MESSAGE_SUCCESS = 'SUCCESS';
  public static MESSAGE_ERROR = 'ERROR';
  public static MESSAGE_INFO = 'INFO';
  public static MESSAGE_WARNING = 'WARNING';
}



// WEBPACK FOOTER //
// ./src/app/view/settings/app-settings.ts